<template>
<!-- 客源审核 -->
<section class="viewContainer">
  <!-- 列表 -->
  <div class="main_container">
    <div style="width: 98%;margin: 10px auto;">
      <b>数据统计</b>
      <div style="display: flex;justify-content: space-between;margin-top: 20px;">
        <span>累计审核：100条</span>
        <span style="color: #E6A23C;">今日审核：0  条</span>
        <span style="color: #E6A23C;">可审数据：100 条</span>
        <el-button type="warning" @click="handlehqsj">获取数据</el-button>
      </div>
      <div>
        <b>审核规则：</b>
        <ul style="line-height: 26px;margin-top: 10px;">
          <li>1.当可审数据大于0条时，先单击获取要审核的客户数据。</li>
          <li>2.审核的数据每次最多可获取10条，审核时间为60分钟，若60分钟内没有审核完成，数据将自动刷新释放。</li>
          <li>3.审核步骤： 先单击呼叫客户，根据弹窗小程序码，进行微信扫码后快速拨号呼叫该客户；关闭呼叫客户弹窗后，单击对应客户审核按钮，进行需求审   核；完成审核后，当前列表数据会自动刷新。</li>
        </ul>
      </div>
    </div>
    <section class="model_section">
      <p class="model_top_title">审核中数据</p>
      <span style="color: #E6A23C;margin-left: 10px;">当前数据将: 28分29秒后将释放</span>
    </section>
    <div class="table_container">
      <el-table :data="chargebackList" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="客户编号" align="center" width="130">
          <template scope="scope">{{scope.row.userphone}}</template>
        </el-table-column>
        <el-table-column label="客户姓名" align="center">
          <template scope="scope">{{scope.row.cityname}}</template>
        </el-table-column>
        <el-table-column label="城市" align="center">
          <template scope="scope">{{scope.row.customername}}</template>
        </el-table-column>
        <el-table-column label="小区" align="center" width="130">
          <template scope="scope">{{scope.row.customerphone}}</template>
        </el-table-column>
        <el-table-column label="户型" align="center">
          <template scope="scope">{{scope.row.housetypename}}</template>
        </el-table-column>
        <el-table-column label="面积" align="center">
          <template scope="scope">{{scope.row.floorspace}}</template>
        </el-table-column>
        <el-table-column label="客户需求" align="center" width="150">
          <template scope="scope">
            <span class="spanList" :title="scope.row.cluetypes">{{scope.row.cluetypes}}</span>  
          </template>
        </el-table-column>
        <el-table-column label="登记日期" align="center" width="120">
          <template scope="scope">{{scope.row.regtime}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="200">
          <template slot-scope="scope">
            <span class="handle" @click="showBillWatch(scope.row)"> 呼叫 </span>
            <span class="handle" @click="addPartner(scope.row)"> 审核 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="currentchangeOne"
      :page-size="10" :total="totalOne" :current-page="pageIndexOne" style="margin:10px 0;float:right;"/>
    </div>
  </div>

  <!-- 呼叫客户 -->
  <el-dialog title="呼叫客户" :visible.sync="isBillWatch" width="20%" center @close="closeWxsmzf">
    <div style="width: 90%; margin: 0 auto; text-align: center;">
      <div><b style="font-size: 20px;">微信扫一扫，快速呼叫客户</b></div>
      <img :src="wxSmzfImg" style="width: 200px;"/><br>
      <el-button type="primary" @click="closeWxsmzf">关闭</el-button>
    </div>
  </el-dialog>
  
  <!-- 审核 右侧抽屉组件 -->
  <el-drawer title="审核" custom-class="registrationRecord" :visible.sync="isInfor" size="40%">
    <div style="display: flex;justify-content: space-between;margin-bottom: 10px;margin-top: -10px;">
      <b>客户信息：</b>
      <span style="color: #F56C6C;">登记日期：{{createtime}}</span>
    </div>
    <el-form style="display: flex; flex-wrap: wrap;">
      <el-form-item label="客户姓名：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="khname" placeholder="请输入客户姓名" maxlength="20" style="width: 90%;"/>
      </el-form-item>
      <!-- <el-form-item label="手机号码：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="sjhm" placeholder="请输入手机号码" maxlength="11" style="width: 90%;" disabled/>
      </el-form-item> -->
      <el-form-item label="所在城市：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-cascader v-model="szcsid" placeholder="请选择所在城市" :options="csOptions"
          filterable clearable @change="changeszcs" style="width:100%;"/>
      </el-form-item>
      <el-form-item label="小区名称：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="xqname" placeholder="请输入小区名称" maxlength="20" style="width: 90%;"/>
      </el-form-item>
      <el-form-item label="房屋户型：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="fwhx" placeholder="请选择房屋户型" style="width: 90%;"/>
      </el-form-item>
      <el-form-item label="房屋面积：" style="display: flex;width: 33.33%;margin-bottom: 10px;">
        <el-input v-model="fwmj" placeholder="请输入房屋面积" maxlength="20" style="width: 100%;">
          <i slot="suffix" style="margin-right: 10px;line-height: 36px;">㎡</i>
        </el-input>
      </el-form-item>
    </el-form>
    <div style="display: flex; margin-bottom: 10px;">
      <b>客户需求:</b> <span>（多选）</span>
    </div>
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="(option, index) in khxqOption" :key="option.cluetypeid"
      :style="{ flex: (index % 2 === 0 && index + 1 === khxqOption.length) ||
      (index % 2 === 0 && khxqOption[index + 1] === undefined) ? '0 0 50%' : '0 0 33.33%' }">
        <div style="display: flex;margin: 0 15px 15px 0;">
          <div class="khxqcheckbox"><el-checkbox v-model="option.selected"/></div>
          <span class="khxqspan">{{ option.cluetypename }}</span>
          <!-- <el-input placeholder="请输入内容" v-model="option.price" disabled>
            <i slot="suffix" style="margin-right: 10px;line-height: 36px;">元</i>
          </el-input> -->
        </div>
      </div>
    </div>

    <div style="display: flex; margin-bottom: 10px;">
      <b>需求周期：</b>
    </div>
    <div style="width: 100%;display: flex;flex-wrap: wrap;">
      <div v-for="(item, index) in items" :key="item.id" class="xqzqclass"
        :class="{ 'selected': selectedIndex === index }" @click="selectItem(index)">
        <span style="font-size: 14px;">{{ item.days }}</span>
      </div>
    </div>

    <el-form>
    <el-form-item label="需求描述：（选填）">
      <!-- placeholder="请输入需求描述，最多输入100个字" -->
      <el-input type="textarea" v-model="desc" :rows="3" maxlength="100" show-word-limit/>
    </el-form-item>
    </el-form>
    <!-- <el-checkbox v-model="invalidCustomer" :disabled="youxiao!=1" style="margin-bottom: 30px;color: #F56C6C;">设置为无效客户（谨慎操作）</el-checkbox> -->
    <div style="text-align:center">
      <el-button type="info" @click="editSubmit(1)">无效客户</el-button>
      <el-button type="danger" @click="editSubmit(0)">无效需求</el-button>
    </div>
  </el-drawer>
  
  <!-- 重要提示 -->
  <el-dialog title="重要提示" :visible.sync="importantNote" width="20%" center>
    <div style="width: 90%; margin: 0 auto; text-align: center;">
      <div style="margin-bottom: 20px;"><b>当前已无数据可审核，请稍后再试。</b></div>
      <el-button type="danger" @click="importantNote = false">我知道了</el-button>
    </div>
  </el-dialog>
  
  <!-- 重要提示Two -->
  <el-dialog title="重要提示" :visible.sync="examinevisible" width="20%" center>
      <div style="width: 95%; margin: 0 auto; margin-bottom: 20px;">
        <b>确认当前客户为无效客户吗？提交后该客源数据将不可见，无法变更审核结果。请谨慎操作。</b>
        <el-checkbox v-model="bzts" style="margin-top: 10px;">不再提示</el-checkbox>
      </div>
      <div style="text-align:center">
        <el-button @click="examinevisible = false">取消</el-button>
        <el-button type="danger" @click="handlezyts()">确定</el-button>
      </div>
  </el-dialog>
  
</section>
</template>
<script>
import { provincegetcountys } from '../../api/newOss';
import { usercustomergetlist, cluegettypes, customergetinfo, customerchan } from "../../api/shopWindow";
export default {
  data() {
    return {
      chargebackList: [], // 全部客户
      pageIndexOne: 1, // 页码
      totalOne: 0, // 总条数
      customerid: "", // 客户ID
      isBillWatch: false, // 抽屉-通话记录
      wxSmzfImg: '', // 二维码
      
      isInfor: false, // 审核
      createtime: '', // 登记日期
      khname: '',
      sjhm: '',
      
      shengId: 0,
      shiId: 0,
      qxId: 0,
      szcsid: [],
      csOptions: [],

      xqname: '',
      fwhx: '',
      fwmj: '',

      khxqOption: [], // 客户需求动态选项
      
      desc: '', // 需求描述
      items: [
        { id: 1, days: '7天' },
        { id: 2, days: '15天' },
        { id: 3, days: '30天' },
        { id: 4, days: '2个月' },
        { id: 5, days: '3个月' },
        { id: 6, days: '4个月' },
        { id: 7, days: '5个月' },
        { id: 8, days: '6个月以上' },
      ],
      selectedIndex: 0, // 默认选中第一项
      invalidCustomer: false, // 无效客户
      youxiao: '', // 有效

      importantNote: false,

      examinevisible: false,
      bzts: false,

    };
  },
  methods: {
    // 获取数据
    handlehqsj(){
      this.importantNote = true;
      // this.getorder();
    },
    // 重要提示Two - 确定
    handlezyts(){
      this.examinevisible = false;
    },
    // 获取全部客户列表
    getorder() {
      let obj = {
        pid: this.provinceId, // 省份ID
        cid: this.cityId, // 城市ID
        pageindex: this.pageIndexOne,
        pagesize: 10
      };
      usercustomergetlist(obj).then(data => {
        if(data.resultCode == 1){
          this.chargebackList = data.resultObj.list;
          this.totalOne = data.resultObj.totalcount;
        }else{
          this.chargebackList = [];
          this.totalOne = 0;
        }
      })
    },
    // 分页
    currentchangeOne(val) {
      this.pageIndexOne = val;
      this.getorder();
    },
    // 查询
    onSubmit() {
      this.pageIndexOne = 1;
      this.getorder();
    },
    selectItem(index) {
      this.selectedIndex = index;
    },
    // 审核
    addPartner(row){
      this.czssq(); // 获取详情省市区
      this.customerid = row.customerid; // 客户ID
      this.isInfor = true;
      // this.fetchOptions(row.id);
      
      // 回显数据 - 调用回显接口
      customergetinfo('', this.customerid).then(data => {
        if(data.resultCode == 1){
          this.khxqInfo = data.resultObj;
          this.createtime = this.khxqInfo.createtime; // 登记日期
          this.khname = this.khxqInfo.customername;
          this.sjhm = this.khxqInfo.phone;
          this.szcsid = [this.khxqInfo.provinceid,this.khxqInfo.cityid,this.khxqInfo.countyid];
          this.xqname = this.khxqInfo.address;
          this.fwhx = this.khxqInfo.housetypename;
          this.fwmj = this.khxqInfo.floorspace;
          this.khxqOption = this.khxqInfo.cluetypelist.map(option => ({
            ...option,
            selected: false // 添加 selected 属性并初始化为 true
          }));
          // this.cyclename = this.khxqInfo.cyclename; // 需求周期
          this.items.map(item => {
            if(item.days == this.khxqInfo.cyclename){
              this.selectedIndex = item.id - 1;
            }
          })
          this.desc = this.khxqInfo.remark; // 需求描述
          this.youxiao = this.khxqInfo.status; // 状态：1=有效 2=已过期 3=无效
        }
      });
    },
    // 客户需求字典
    fetchOptions(rowid) {
      let obj = {
        pid: this.provinceId, // 省份ID
        cid: this.cityId, // 城市ID
      };
      cluegettypes(obj).then(data => {
        if(data.resultCode == 1){
          this.khxqOption = data.resultObj;
        }
      });
    },
    // 无效客户/无效需求
    editSubmit(isinvalid){
      let unselectedIds = this.khxqOption.filter(option => option.selected).map(option => option.cluetypeid);
      if (isinvalid == 0 && unselectedIds.length<1){
        this.$swal({
          type: "warning",
          text: "请勾选无效的客户需求",
        });
        return false;
      }
      let obj = {
        customerid: this.customerid, // 客户ID
        cluetypes: isinvalid==1?[]:unselectedIds, // 需要设为无效的需求ID集合
        isinvalid: isinvalid, // 客户是否设为无效 0=否 1=是
      };
      customerchan(obj).then(data => {
        if(data.resultCode == 1){
          this.$swal({
            type:"success",
            text:"操作成功"
          })
          this.getorder();
          this.isInfor = false;
        }else{
          this.$swal({
            type:'error',
            text: data.resultMsg,
          })
        }
      })
    },
    // 呼叫
    showBillWatch(row) {
      this.isBillWatch = true;
    },
    // 二维码弹框-关闭
    closeWxsmzf() {
      this.isBillWatch = false; // 二维码弹窗消失
    },
    // 请选择省市
    changeszcs(val) {
      this.shengId = val[0]; // 省
      this.shiId = val[1]; // 市
      this.qxId = val[2]; // 区
    },
    // 查找省市区
    czssq() {
      let loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          item.citys.forEach(city => {
            const cityObj = {
              value: city.cid, label: city.cname,
              children: city.countys.map(zone => ({
                value: zone.scid, label: zone.scname
              }))
            };
            province.children.push(cityObj);
          });
          provinceOptions.push(province);
        });
        this.csOptions = provinceOptions;
      }).catch(error => {
        console.error('获取省市区数据失败:', error);
      });
    },
    
  },
  mounted() {
    this.getorder();
  }
};
</script>
<style scoped>
.khxqcheckbox{
  min-width: 42px;
  height: 38px;
  line-height: 38px;
  background: #F5F7FA;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border: 1px solid #DCDFE6;
  text-align: center;
  margin-right: -1px;
}
.khxqspan{
  display: block;
  min-width: 90px;
  height: 38px;
  line-height: 38px;
  background: #F5F7FA;
  border: 1px solid #DCDFE6;
  text-align: center;
  margin-right: -2px;
  z-index: 999;
}
.xqzqclass {
  width: 80px;
  height: 30px;
  margin: 0 10px 10px 0;
  text-align: center;
  background-color: #ccc;
  color: white;
  cursor: pointer;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: normal; /* 允许文本换行 */
  word-break: break-all; /* 确保长文本也能换行 */
}

.xqzqclass.selected {
  background-color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// customersourcereview.vue?0b36462f